import { useEffect } from 'react';

/**
 * Shows the browser's "leave site?" prompt on reload / tab close while `enabled`.
 *
 * In-app navigation is deliberately not blocked: the shipment draft lives in Redux and survives
 * moving between pages, so only a browser-level unload actually loses it.
 */
export function useUnsavedChangesWarning(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      // Browsers show their own wording; they only require the event to be cancelled.
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [enabled]);
}
